import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './context/store';
import Login from './pages/Login';
import BrandSelect from './pages/BrandSelect';
import Dashboard from './pages/Dashboard';
import BookingConfirmation from './pages/BookingConfirmation';
import PaymentReceived from './pages/PaymentReceived';
import PaymentReminder from './pages/PaymentReminder';
import PDFContent from './pages/PDFContent';
import ConfirmedBookings from './pages/ConfirmedBookings';
import EditBooking from './pages/EditBooking';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminActivityLog from './pages/admin/AdminActivityLog';
import AdminAgents from './pages/admin/AdminAgents';
import AdminBookings from './pages/admin/AdminBookings';
import AdminSettings from './pages/admin/AdminSettings';
import AdminProfitMargins from './pages/admin/AdminProfitMargins';
import AdminDeclarations from './pages/admin/AdminDeclarations';
import AdminCoupons from './pages/admin/AdminCoupons';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';

function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuthStore();
  if (!user) return <Navigate to="/select-company" replace />;
  if (adminOnly && user.role !== 'superadmin') return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <Router>
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      <Routes>
        <Route path="/select-company" element={<BrandSelect />} />
        <Route path="/login" element={<Login />} />
        
        {/* Agent Routes */}
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="booking-confirmation" element={<BookingConfirmation />} />
          <Route path="payment-received" element={<PaymentReceived />} />
          <Route path="payment-reminder" element={<PaymentReminder />} />
          <Route path="pdf-content" element={<PDFContent />} />
          <Route path="confirmed-bookings" element={<ConfirmedBookings />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
          <Route index element={<AdminDashboard />} />
          <Route path="activity-log" element={<AdminActivityLog />} />
          <Route path="agents" element={<AdminAgents />} />
          <Route path="bookings" element={<AdminBookings />} />
          <Route path="edit-booking/:id" element={<EditBooking />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="profit-margins" element={<AdminProfitMargins />} />
          <Route path="declarations" element={<AdminDeclarations />} />
          <Route path="coupons" element={<AdminCoupons />} />
        </Route>
      </Routes>
    </Router>
  );
}
